// source: no/jotta/internal/order.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var no_jotta_internal_ping_pb = require('../../../no/jotta/internal/ping_pb.js');
goog.object.extend(proto, no_jotta_internal_ping_pb);
var no_jotta_openapi_subscription_payment_v2_pb = require('../../../no/jotta/openapi/subscription/payment.v2_pb.js');
goog.object.extend(proto, no_jotta_openapi_subscription_payment_v2_pb);
var no_jotta_openapi_language_pb = require('../../../no/jotta/openapi/language_pb.js');
goog.object.extend(proto, no_jotta_openapi_language_pb);
goog.exportSymbol('proto.no.jotta.internal.AddPriceRequest', null, global);
goog.exportSymbol('proto.no.jotta.internal.AddPriceResponse', null, global);
goog.exportSymbol('proto.no.jotta.internal.AddProductRequest', null, global);
goog.exportSymbol('proto.no.jotta.internal.AddProductResponse', null, global);
goog.exportSymbol('proto.no.jotta.internal.GetActiveSubscriptionRequest', null, global);
goog.exportSymbol('proto.no.jotta.internal.GetActiveSubscriptionResponse', null, global);
goog.exportSymbol('proto.no.jotta.internal.GetProductRequest', null, global);
goog.exportSymbol('proto.no.jotta.internal.GetProductResponse', null, global);
goog.exportSymbol('proto.no.jotta.internal.GetScopedProductRequest', null, global);
goog.exportSymbol('proto.no.jotta.internal.GetScopedProductResponse', null, global);
goog.exportSymbol('proto.no.jotta.internal.IAPType', null, global);
goog.exportSymbol('proto.no.jotta.internal.InitializeIAPSubscriptionRequest', null, global);
goog.exportSymbol('proto.no.jotta.internal.InitializeIAPSubscriptionResponse', null, global);
goog.exportSymbol('proto.no.jotta.internal.ListProductsRequest', null, global);
goog.exportSymbol('proto.no.jotta.internal.ListProductsResponse', null, global);
goog.exportSymbol('proto.no.jotta.internal.Product', null, global);
goog.exportSymbol('proto.no.jotta.internal.Product.Scope', null, global);
goog.exportSymbol('proto.no.jotta.internal.ProductData', null, global);
goog.exportSymbol('proto.no.jotta.internal.ProductData.ProductCustomerGroup', null, global);
goog.exportSymbol('proto.no.jotta.internal.ProductPrice', null, global);
goog.exportSymbol('proto.no.jotta.internal.ProductPrices', null, global);
goog.exportSymbol('proto.no.jotta.internal.RemoveProductRequest', null, global);
goog.exportSymbol('proto.no.jotta.internal.RemoveProductResponse', null, global);
goog.exportSymbol('proto.no.jotta.internal.Subscription', null, global);
goog.exportSymbol('proto.no.jotta.internal.SubscriptionInterval', null, global);
goog.exportSymbol('proto.no.jotta.internal.Translations', null, global);
goog.exportSymbol('proto.no.jotta.internal.Translations.Translation', null, global);
goog.exportSymbol('proto.no.jotta.internal.UpdateCardRequest', null, global);
goog.exportSymbol('proto.no.jotta.internal.UpdateCardResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.Translations = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.internal.Translations.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.internal.Translations, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.Translations.displayName = 'proto.no.jotta.internal.Translations';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.Translations.Translation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.Translations.Translation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.Translations.Translation.displayName = 'proto.no.jotta.internal.Translations.Translation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.Product = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.Product, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.Product.displayName = 'proto.no.jotta.internal.Product';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.Subscription = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.internal.Subscription.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.internal.Subscription, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.Subscription.displayName = 'proto.no.jotta.internal.Subscription';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.ListProductsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.ListProductsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.ListProductsRequest.displayName = 'proto.no.jotta.internal.ListProductsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.ListProductsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.internal.ListProductsResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.internal.ListProductsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.ListProductsResponse.displayName = 'proto.no.jotta.internal.ListProductsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.GetActiveSubscriptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.GetActiveSubscriptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.GetActiveSubscriptionRequest.displayName = 'proto.no.jotta.internal.GetActiveSubscriptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.GetActiveSubscriptionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.GetActiveSubscriptionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.GetActiveSubscriptionResponse.displayName = 'proto.no.jotta.internal.GetActiveSubscriptionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.InitializeIAPSubscriptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.InitializeIAPSubscriptionRequest.displayName = 'proto.no.jotta.internal.InitializeIAPSubscriptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.InitializeIAPSubscriptionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.InitializeIAPSubscriptionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.InitializeIAPSubscriptionResponse.displayName = 'proto.no.jotta.internal.InitializeIAPSubscriptionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.UpdateCardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.UpdateCardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.UpdateCardRequest.displayName = 'proto.no.jotta.internal.UpdateCardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.UpdateCardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.UpdateCardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.UpdateCardResponse.displayName = 'proto.no.jotta.internal.UpdateCardResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.GetProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.GetProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.GetProductRequest.displayName = 'proto.no.jotta.internal.GetProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.ProductPrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.ProductPrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.ProductPrice.displayName = 'proto.no.jotta.internal.ProductPrice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.ProductPrices = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.internal.ProductPrices.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.internal.ProductPrices, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.ProductPrices.displayName = 'proto.no.jotta.internal.ProductPrices';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.ProductData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.internal.ProductData.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.internal.ProductData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.ProductData.displayName = 'proto.no.jotta.internal.ProductData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.ProductData.ProductCustomerGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.ProductData.ProductCustomerGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.ProductData.ProductCustomerGroup.displayName = 'proto.no.jotta.internal.ProductData.ProductCustomerGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.GetProductResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.GetProductResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.GetProductResponse.displayName = 'proto.no.jotta.internal.GetProductResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.GetScopedProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.GetScopedProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.GetScopedProductRequest.displayName = 'proto.no.jotta.internal.GetScopedProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.GetScopedProductResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.internal.GetScopedProductResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.internal.GetScopedProductResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.GetScopedProductResponse.displayName = 'proto.no.jotta.internal.GetScopedProductResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.AddPriceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.AddPriceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.AddPriceRequest.displayName = 'proto.no.jotta.internal.AddPriceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.AddPriceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.AddPriceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.AddPriceResponse.displayName = 'proto.no.jotta.internal.AddPriceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.AddProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.AddProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.AddProductRequest.displayName = 'proto.no.jotta.internal.AddProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.AddProductResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.AddProductResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.AddProductResponse.displayName = 'proto.no.jotta.internal.AddProductResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.RemoveProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.RemoveProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.RemoveProductRequest.displayName = 'proto.no.jotta.internal.RemoveProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.internal.RemoveProductResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.internal.RemoveProductResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.internal.RemoveProductResponse.displayName = 'proto.no.jotta.internal.RemoveProductResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.internal.Translations.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.Translations.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.Translations.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.Translations} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.Translations.toObject = function(includeInstance, msg) {
  var f, obj = {
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.no.jotta.internal.Translations.Translation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.Translations}
 */
proto.no.jotta.internal.Translations.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.Translations;
  return proto.no.jotta.internal.Translations.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.Translations} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.Translations}
 */
proto.no.jotta.internal.Translations.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.internal.Translations.Translation;
      reader.readMessage(value,proto.no.jotta.internal.Translations.Translation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.Translations.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.Translations.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.Translations} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.Translations.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.internal.Translations.Translation.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.Translations.Translation.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.Translations.Translation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.Translations.Translation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.Translations.Translation.toObject = function(includeInstance, msg) {
  var f, obj = {
    language: jspb.Message.getFieldWithDefault(msg, 1, 0),
    text: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.Translations.Translation}
 */
proto.no.jotta.internal.Translations.Translation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.Translations.Translation;
  return proto.no.jotta.internal.Translations.Translation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.Translations.Translation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.Translations.Translation}
 */
proto.no.jotta.internal.Translations.Translation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.Language} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.Translations.Translation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.Translations.Translation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.Translations.Translation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.Translations.Translation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional no.jotta.openapi.Language language = 1;
 * @return {!proto.no.jotta.openapi.Language}
 */
proto.no.jotta.internal.Translations.Translation.prototype.getLanguage = function() {
  return /** @type {!proto.no.jotta.openapi.Language} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.Language} value
 * @return {!proto.no.jotta.internal.Translations.Translation} returns this
 */
proto.no.jotta.internal.Translations.Translation.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.no.jotta.internal.Translations.Translation.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.Translations.Translation} returns this
 */
proto.no.jotta.internal.Translations.Translation.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Translation translations = 1;
 * @return {!Array<!proto.no.jotta.internal.Translations.Translation>}
 */
proto.no.jotta.internal.Translations.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.no.jotta.internal.Translations.Translation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.internal.Translations.Translation, 1));
};


/**
 * @param {!Array<!proto.no.jotta.internal.Translations.Translation>} value
 * @return {!proto.no.jotta.internal.Translations} returns this
*/
proto.no.jotta.internal.Translations.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.internal.Translations.Translation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.internal.Translations.Translation}
 */
proto.no.jotta.internal.Translations.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.internal.Translations.Translation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.internal.Translations} returns this
 */
proto.no.jotta.internal.Translations.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.Product.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.Product.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.Product} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.Product.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    storage: jspb.Message.getFieldWithDefault(msg, 2, 0),
    scope: jspb.Message.getFieldWithDefault(msg, 3, 0),
    free: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    id: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.Product}
 */
proto.no.jotta.internal.Product.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.Product;
  return proto.no.jotta.internal.Product.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.Product} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.Product}
 */
proto.no.jotta.internal.Product.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStorage(value);
      break;
    case 3:
      var value = /** @type {!proto.no.jotta.internal.Product.Scope} */ (reader.readEnum());
      msg.setScope(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFree(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.Product.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.Product.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.Product} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.Product.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStorage();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getScope();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getFree();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.internal.Product.Scope = {
  UNKNOWN_SCOPE: 0,
  PERSONAL: 1,
  HOME: 2,
  BUSINESS: 3,
  OTHER: 4
};

/**
 * optional string code = 1;
 * @return {string}
 */
proto.no.jotta.internal.Product.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.Product} returns this
 */
proto.no.jotta.internal.Product.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 storage = 2;
 * @return {number}
 */
proto.no.jotta.internal.Product.prototype.getStorage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.internal.Product} returns this
 */
proto.no.jotta.internal.Product.prototype.setStorage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional Scope scope = 3;
 * @return {!proto.no.jotta.internal.Product.Scope}
 */
proto.no.jotta.internal.Product.prototype.getScope = function() {
  return /** @type {!proto.no.jotta.internal.Product.Scope} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.no.jotta.internal.Product.Scope} value
 * @return {!proto.no.jotta.internal.Product} returns this
 */
proto.no.jotta.internal.Product.prototype.setScope = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional bool free = 4;
 * @return {boolean}
 */
proto.no.jotta.internal.Product.prototype.getFree = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.internal.Product} returns this
 */
proto.no.jotta.internal.Product.prototype.setFree = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional int32 id = 6;
 * @return {number}
 */
proto.no.jotta.internal.Product.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.internal.Product} returns this
 */
proto.no.jotta.internal.Product.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.internal.Subscription.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.Subscription.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.Subscription.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.Subscription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.Subscription.toObject = function(includeInstance, msg) {
  var f, obj = {
    interval: jspb.Message.getFieldWithDefault(msg, 1, 0),
    productsList: jspb.Message.toObjectList(msg.getProductsList(),
    proto.no.jotta.internal.Product.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.Subscription}
 */
proto.no.jotta.internal.Subscription.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.Subscription;
  return proto.no.jotta.internal.Subscription.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.Subscription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.Subscription}
 */
proto.no.jotta.internal.Subscription.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.internal.SubscriptionInterval} */ (reader.readEnum());
      msg.setInterval(value);
      break;
    case 2:
      var value = new proto.no.jotta.internal.Product;
      reader.readMessage(value,proto.no.jotta.internal.Product.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.Subscription.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.Subscription.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.Subscription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.Subscription.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInterval();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.no.jotta.internal.Product.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionInterval interval = 1;
 * @return {!proto.no.jotta.internal.SubscriptionInterval}
 */
proto.no.jotta.internal.Subscription.prototype.getInterval = function() {
  return /** @type {!proto.no.jotta.internal.SubscriptionInterval} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.internal.SubscriptionInterval} value
 * @return {!proto.no.jotta.internal.Subscription} returns this
 */
proto.no.jotta.internal.Subscription.prototype.setInterval = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated Product products = 2;
 * @return {!Array<!proto.no.jotta.internal.Product>}
 */
proto.no.jotta.internal.Subscription.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.no.jotta.internal.Product>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.internal.Product, 2));
};


/**
 * @param {!Array<!proto.no.jotta.internal.Product>} value
 * @return {!proto.no.jotta.internal.Subscription} returns this
*/
proto.no.jotta.internal.Subscription.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.no.jotta.internal.Product=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.internal.Product}
 */
proto.no.jotta.internal.Subscription.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.no.jotta.internal.Product, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.internal.Subscription} returns this
 */
proto.no.jotta.internal.Subscription.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.ListProductsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.ListProductsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.ListProductsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.ListProductsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerGroup: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.ListProductsRequest}
 */
proto.no.jotta.internal.ListProductsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.ListProductsRequest;
  return proto.no.jotta.internal.ListProductsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.ListProductsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.ListProductsRequest}
 */
proto.no.jotta.internal.ListProductsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerGroup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.ListProductsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.ListProductsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.ListProductsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.ListProductsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string customer_group = 1;
 * @return {string}
 */
proto.no.jotta.internal.ListProductsRequest.prototype.getCustomerGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.ListProductsRequest} returns this
 */
proto.no.jotta.internal.ListProductsRequest.prototype.setCustomerGroup = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.internal.ListProductsRequest} returns this
 */
proto.no.jotta.internal.ListProductsRequest.prototype.clearCustomerGroup = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.internal.ListProductsRequest.prototype.hasCustomerGroup = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.internal.ListProductsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.ListProductsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.ListProductsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.ListProductsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.ListProductsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    productsList: jspb.Message.toObjectList(msg.getProductsList(),
    proto.no.jotta.internal.Product.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.ListProductsResponse}
 */
proto.no.jotta.internal.ListProductsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.ListProductsResponse;
  return proto.no.jotta.internal.ListProductsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.ListProductsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.ListProductsResponse}
 */
proto.no.jotta.internal.ListProductsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.internal.Product;
      reader.readMessage(value,proto.no.jotta.internal.Product.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.ListProductsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.ListProductsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.ListProductsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.ListProductsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.internal.Product.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Product products = 1;
 * @return {!Array<!proto.no.jotta.internal.Product>}
 */
proto.no.jotta.internal.ListProductsResponse.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.no.jotta.internal.Product>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.internal.Product, 1));
};


/**
 * @param {!Array<!proto.no.jotta.internal.Product>} value
 * @return {!proto.no.jotta.internal.ListProductsResponse} returns this
*/
proto.no.jotta.internal.ListProductsResponse.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.internal.Product=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.internal.Product}
 */
proto.no.jotta.internal.ListProductsResponse.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.internal.Product, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.internal.ListProductsResponse} returns this
 */
proto.no.jotta.internal.ListProductsResponse.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.GetActiveSubscriptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.GetActiveSubscriptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.GetActiveSubscriptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.GetActiveSubscriptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.GetActiveSubscriptionRequest}
 */
proto.no.jotta.internal.GetActiveSubscriptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.GetActiveSubscriptionRequest;
  return proto.no.jotta.internal.GetActiveSubscriptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.GetActiveSubscriptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.GetActiveSubscriptionRequest}
 */
proto.no.jotta.internal.GetActiveSubscriptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.GetActiveSubscriptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.GetActiveSubscriptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.GetActiveSubscriptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.GetActiveSubscriptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.no.jotta.internal.GetActiveSubscriptionRequest.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.GetActiveSubscriptionRequest} returns this
 */
proto.no.jotta.internal.GetActiveSubscriptionRequest.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.GetActiveSubscriptionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.GetActiveSubscriptionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.GetActiveSubscriptionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.GetActiveSubscriptionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    subscription: (f = msg.getSubscription()) && proto.no.jotta.internal.Subscription.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.GetActiveSubscriptionResponse}
 */
proto.no.jotta.internal.GetActiveSubscriptionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.GetActiveSubscriptionResponse;
  return proto.no.jotta.internal.GetActiveSubscriptionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.GetActiveSubscriptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.GetActiveSubscriptionResponse}
 */
proto.no.jotta.internal.GetActiveSubscriptionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.internal.Subscription;
      reader.readMessage(value,proto.no.jotta.internal.Subscription.deserializeBinaryFromReader);
      msg.setSubscription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.GetActiveSubscriptionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.GetActiveSubscriptionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.GetActiveSubscriptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.GetActiveSubscriptionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscription();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.internal.Subscription.serializeBinaryToWriter
    );
  }
};


/**
 * optional Subscription subscription = 1;
 * @return {?proto.no.jotta.internal.Subscription}
 */
proto.no.jotta.internal.GetActiveSubscriptionResponse.prototype.getSubscription = function() {
  return /** @type{?proto.no.jotta.internal.Subscription} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.internal.Subscription, 1));
};


/**
 * @param {?proto.no.jotta.internal.Subscription|undefined} value
 * @return {!proto.no.jotta.internal.GetActiveSubscriptionResponse} returns this
*/
proto.no.jotta.internal.GetActiveSubscriptionResponse.prototype.setSubscription = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.internal.GetActiveSubscriptionResponse} returns this
 */
proto.no.jotta.internal.GetActiveSubscriptionResponse.prototype.clearSubscription = function() {
  return this.setSubscription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.internal.GetActiveSubscriptionResponse.prototype.hasSubscription = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.InitializeIAPSubscriptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.InitializeIAPSubscriptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    productId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    orderId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    interval: jspb.Message.getFieldWithDefault(msg, 5, 0),
    expiresAtMillis: jspb.Message.getFieldWithDefault(msg, 6, 0),
    startedAtMillis: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.InitializeIAPSubscriptionRequest}
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.InitializeIAPSubscriptionRequest;
  return proto.no.jotta.internal.InitializeIAPSubscriptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.InitializeIAPSubscriptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.InitializeIAPSubscriptionRequest}
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.internal.IAPType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 5:
      var value = /** @type {!proto.no.jotta.internal.SubscriptionInterval} */ (reader.readEnum());
      msg.setInterval(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiresAtMillis(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartedAtMillis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.InitializeIAPSubscriptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.InitializeIAPSubscriptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getInterval();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getExpiresAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getStartedAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.InitializeIAPSubscriptionRequest} returns this
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional IAPType type = 2;
 * @return {!proto.no.jotta.internal.IAPType}
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.prototype.getType = function() {
  return /** @type {!proto.no.jotta.internal.IAPType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.internal.IAPType} value
 * @return {!proto.no.jotta.internal.InitializeIAPSubscriptionRequest} returns this
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string product_id = 3;
 * @return {string}
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.InitializeIAPSubscriptionRequest} returns this
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string order_id = 4;
 * @return {string}
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.InitializeIAPSubscriptionRequest} returns this
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional SubscriptionInterval interval = 5;
 * @return {!proto.no.jotta.internal.SubscriptionInterval}
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.prototype.getInterval = function() {
  return /** @type {!proto.no.jotta.internal.SubscriptionInterval} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.no.jotta.internal.SubscriptionInterval} value
 * @return {!proto.no.jotta.internal.InitializeIAPSubscriptionRequest} returns this
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.prototype.setInterval = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int64 expires_at_millis = 6;
 * @return {number}
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.prototype.getExpiresAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.internal.InitializeIAPSubscriptionRequest} returns this
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.prototype.setExpiresAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 started_at_millis = 7;
 * @return {number}
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.prototype.getStartedAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.internal.InitializeIAPSubscriptionRequest} returns this
 */
proto.no.jotta.internal.InitializeIAPSubscriptionRequest.prototype.setStartedAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.InitializeIAPSubscriptionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.InitializeIAPSubscriptionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.InitializeIAPSubscriptionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.InitializeIAPSubscriptionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.InitializeIAPSubscriptionResponse}
 */
proto.no.jotta.internal.InitializeIAPSubscriptionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.InitializeIAPSubscriptionResponse;
  return proto.no.jotta.internal.InitializeIAPSubscriptionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.InitializeIAPSubscriptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.InitializeIAPSubscriptionResponse}
 */
proto.no.jotta.internal.InitializeIAPSubscriptionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.InitializeIAPSubscriptionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.InitializeIAPSubscriptionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.InitializeIAPSubscriptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.InitializeIAPSubscriptionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.UpdateCardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.UpdateCardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.UpdateCardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.UpdateCardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    stripeCustomer: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    last4: jspb.Message.getFieldWithDefault(msg, 3, ""),
    expMonth: jspb.Message.getFieldWithDefault(msg, 4, 0),
    expYear: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.UpdateCardRequest}
 */
proto.no.jotta.internal.UpdateCardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.UpdateCardRequest;
  return proto.no.jotta.internal.UpdateCardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.UpdateCardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.UpdateCardRequest}
 */
proto.no.jotta.internal.UpdateCardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStripeCustomer(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLast4(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExpMonth(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExpYear(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.UpdateCardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.UpdateCardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.UpdateCardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.UpdateCardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStripeCustomer();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLast4();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExpMonth();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getExpYear();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string stripe_customer = 1;
 * @return {string}
 */
proto.no.jotta.internal.UpdateCardRequest.prototype.getStripeCustomer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.UpdateCardRequest} returns this
 */
proto.no.jotta.internal.UpdateCardRequest.prototype.setStripeCustomer = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.no.jotta.internal.UpdateCardRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.UpdateCardRequest} returns this
 */
proto.no.jotta.internal.UpdateCardRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string last4 = 3;
 * @return {string}
 */
proto.no.jotta.internal.UpdateCardRequest.prototype.getLast4 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.UpdateCardRequest} returns this
 */
proto.no.jotta.internal.UpdateCardRequest.prototype.setLast4 = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 exp_month = 4;
 * @return {number}
 */
proto.no.jotta.internal.UpdateCardRequest.prototype.getExpMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.internal.UpdateCardRequest} returns this
 */
proto.no.jotta.internal.UpdateCardRequest.prototype.setExpMonth = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 exp_year = 5;
 * @return {number}
 */
proto.no.jotta.internal.UpdateCardRequest.prototype.getExpYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.internal.UpdateCardRequest} returns this
 */
proto.no.jotta.internal.UpdateCardRequest.prototype.setExpYear = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.UpdateCardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.UpdateCardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.UpdateCardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.UpdateCardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.UpdateCardResponse}
 */
proto.no.jotta.internal.UpdateCardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.UpdateCardResponse;
  return proto.no.jotta.internal.UpdateCardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.UpdateCardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.UpdateCardResponse}
 */
proto.no.jotta.internal.UpdateCardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.UpdateCardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.UpdateCardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.UpdateCardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.UpdateCardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.GetProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.GetProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.GetProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.GetProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    productCode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.GetProductRequest}
 */
proto.no.jotta.internal.GetProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.GetProductRequest;
  return proto.no.jotta.internal.GetProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.GetProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.GetProductRequest}
 */
proto.no.jotta.internal.GetProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.GetProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.GetProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.GetProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.GetProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string product_code = 1;
 * @return {string}
 */
proto.no.jotta.internal.GetProductRequest.prototype.getProductCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.GetProductRequest} returns this
 */
proto.no.jotta.internal.GetProductRequest.prototype.setProductCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.ProductPrice.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.ProductPrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.ProductPrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.ProductPrice.toObject = function(includeInstance, msg) {
  var f, obj = {
    price: (f = msg.getPrice()) && no_jotta_openapi_subscription_payment_v2_pb.Money.toObject(includeInstance, f),
    interval: jspb.Message.getFieldWithDefault(msg, 2, 0),
    startsAtMillis: jspb.Message.getFieldWithDefault(msg, 3, 0),
    endsAtMillis: jspb.Message.getFieldWithDefault(msg, 4, 0),
    renewalPrice: (f = msg.getRenewalPrice()) && no_jotta_openapi_subscription_payment_v2_pb.Money.toObject(includeInstance, f),
    customerGroup: jspb.Message.getFieldWithDefault(msg, 6, ""),
    id: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.ProductPrice}
 */
proto.no.jotta.internal.ProductPrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.ProductPrice;
  return proto.no.jotta.internal.ProductPrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.ProductPrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.ProductPrice}
 */
proto.no.jotta.internal.ProductPrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_subscription_payment_v2_pb.Money;
      reader.readMessage(value,no_jotta_openapi_subscription_payment_v2_pb.Money.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (reader.readEnum());
      msg.setInterval(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartsAtMillis(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndsAtMillis(value);
      break;
    case 5:
      var value = new no_jotta_openapi_subscription_payment_v2_pb.Money;
      reader.readMessage(value,no_jotta_openapi_subscription_payment_v2_pb.Money.deserializeBinaryFromReader);
      msg.setRenewalPrice(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerGroup(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.ProductPrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.ProductPrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.ProductPrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.ProductPrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      no_jotta_openapi_subscription_payment_v2_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getInterval();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getStartsAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getRenewalPrice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      no_jotta_openapi_subscription_payment_v2_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getCustomerGroup();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional no.jotta.openapi.subscription.v2.Money price = 1;
 * @return {?proto.no.jotta.openapi.subscription.v2.Money}
 */
proto.no.jotta.internal.ProductPrice.prototype.getPrice = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.Money} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_subscription_payment_v2_pb.Money, 1));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.Money|undefined} value
 * @return {!proto.no.jotta.internal.ProductPrice} returns this
*/
proto.no.jotta.internal.ProductPrice.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.internal.ProductPrice} returns this
 */
proto.no.jotta.internal.ProductPrice.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.internal.ProductPrice.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional no.jotta.openapi.subscription.v2.SubscriptionInterval interval = 2;
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval}
 */
proto.no.jotta.internal.ProductPrice.prototype.getInterval = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} value
 * @return {!proto.no.jotta.internal.ProductPrice} returns this
 */
proto.no.jotta.internal.ProductPrice.prototype.setInterval = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 starts_at_millis = 3;
 * @return {number}
 */
proto.no.jotta.internal.ProductPrice.prototype.getStartsAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.internal.ProductPrice} returns this
 */
proto.no.jotta.internal.ProductPrice.prototype.setStartsAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 ends_at_millis = 4;
 * @return {number}
 */
proto.no.jotta.internal.ProductPrice.prototype.getEndsAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.internal.ProductPrice} returns this
 */
proto.no.jotta.internal.ProductPrice.prototype.setEndsAtMillis = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.internal.ProductPrice} returns this
 */
proto.no.jotta.internal.ProductPrice.prototype.clearEndsAtMillis = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.internal.ProductPrice.prototype.hasEndsAtMillis = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional no.jotta.openapi.subscription.v2.Money renewal_price = 5;
 * @return {?proto.no.jotta.openapi.subscription.v2.Money}
 */
proto.no.jotta.internal.ProductPrice.prototype.getRenewalPrice = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.Money} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_subscription_payment_v2_pb.Money, 5));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.Money|undefined} value
 * @return {!proto.no.jotta.internal.ProductPrice} returns this
*/
proto.no.jotta.internal.ProductPrice.prototype.setRenewalPrice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.internal.ProductPrice} returns this
 */
proto.no.jotta.internal.ProductPrice.prototype.clearRenewalPrice = function() {
  return this.setRenewalPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.internal.ProductPrice.prototype.hasRenewalPrice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string customer_group = 6;
 * @return {string}
 */
proto.no.jotta.internal.ProductPrice.prototype.getCustomerGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.ProductPrice} returns this
 */
proto.no.jotta.internal.ProductPrice.prototype.setCustomerGroup = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 id = 7;
 * @return {number}
 */
proto.no.jotta.internal.ProductPrice.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.internal.ProductPrice} returns this
 */
proto.no.jotta.internal.ProductPrice.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.internal.ProductPrices.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.ProductPrices.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.ProductPrices.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.ProductPrices} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.ProductPrices.toObject = function(includeInstance, msg) {
  var f, obj = {
    pricesList: jspb.Message.toObjectList(msg.getPricesList(),
    proto.no.jotta.internal.ProductPrice.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.ProductPrices}
 */
proto.no.jotta.internal.ProductPrices.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.ProductPrices;
  return proto.no.jotta.internal.ProductPrices.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.ProductPrices} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.ProductPrices}
 */
proto.no.jotta.internal.ProductPrices.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.internal.ProductPrice;
      reader.readMessage(value,proto.no.jotta.internal.ProductPrice.deserializeBinaryFromReader);
      msg.addPrices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.ProductPrices.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.ProductPrices.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.ProductPrices} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.ProductPrices.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPricesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.internal.ProductPrice.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ProductPrice prices = 1;
 * @return {!Array<!proto.no.jotta.internal.ProductPrice>}
 */
proto.no.jotta.internal.ProductPrices.prototype.getPricesList = function() {
  return /** @type{!Array<!proto.no.jotta.internal.ProductPrice>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.internal.ProductPrice, 1));
};


/**
 * @param {!Array<!proto.no.jotta.internal.ProductPrice>} value
 * @return {!proto.no.jotta.internal.ProductPrices} returns this
*/
proto.no.jotta.internal.ProductPrices.prototype.setPricesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.internal.ProductPrice=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.internal.ProductPrice}
 */
proto.no.jotta.internal.ProductPrices.prototype.addPrices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.internal.ProductPrice, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.internal.ProductPrices} returns this
 */
proto.no.jotta.internal.ProductPrices.prototype.clearPricesList = function() {
  return this.setPricesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.internal.ProductData.repeatedFields_ = [19];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.ProductData.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.ProductData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.ProductData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.ProductData.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    prices: (f = msg.getPrices()) && proto.no.jotta.internal.ProductPrices.toObject(includeInstance, f),
    customerGroupsList: jspb.Message.toObjectList(msg.getCustomerGroupsList(),
    proto.no.jotta.internal.ProductData.ProductCustomerGroup.toObject, includeInstance),
    category: jspb.Message.getFieldWithDefault(msg, 5, ""),
    devices: jspb.Message.getFieldWithDefault(msg, 6, 0),
    mobileDevices: jspb.Message.getFieldWithDefault(msg, 7, 0),
    userSeatCount: jspb.Message.getFieldWithDefault(msg, 8, 0),
    showInRegisterForm: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    pricesWithoutVat: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    translateKey: jspb.Message.getFieldWithDefault(msg, 12, ""),
    interval: jspb.Message.getFieldWithDefault(msg, 13, 0),
    type: jspb.Message.getFieldWithDefault(msg, 14, ""),
    role: jspb.Message.getFieldWithDefault(msg, 15, ""),
    displayParamsJson: jspb.Message.getFieldWithDefault(msg, 16, ""),
    parentProduct: jspb.Message.getFieldWithDefault(msg, 17, ""),
    productGroup: jspb.Message.getFieldWithDefault(msg, 18, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.ProductData}
 */
proto.no.jotta.internal.ProductData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.ProductData;
  return proto.no.jotta.internal.ProductData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.ProductData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.ProductData}
 */
proto.no.jotta.internal.ProductData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.no.jotta.internal.ProductPrices;
      reader.readMessage(value,proto.no.jotta.internal.ProductPrices.deserializeBinaryFromReader);
      msg.setPrices(value);
      break;
    case 19:
      var value = new proto.no.jotta.internal.ProductData.ProductCustomerGroup;
      reader.readMessage(value,proto.no.jotta.internal.ProductData.ProductCustomerGroup.deserializeBinaryFromReader);
      msg.addCustomerGroups(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDevices(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMobileDevices(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserSeatCount(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowInRegisterForm(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPricesWithoutVat(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setTranslateKey(value);
      break;
    case 13:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (reader.readEnum());
      msg.setInterval(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayParamsJson(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentProduct(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductGroup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.ProductData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.ProductData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.ProductData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.ProductData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPrices();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.no.jotta.internal.ProductPrices.serializeBinaryToWriter
    );
  }
  f = message.getCustomerGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      19,
      f,
      proto.no.jotta.internal.ProductData.ProductCustomerGroup.serializeBinaryToWriter
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDevices();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMobileDevices();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getUserSeatCount();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getShowInRegisterForm();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getPricesWithoutVat();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getTranslateKey();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getInterval();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getDisplayParamsJson();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getParentProduct();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getProductGroup();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.ProductData.ProductCustomerGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.ProductData.ProductCustomerGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.ProductData.ProductCustomerGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.ProductData.ProductCustomerGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerGroupCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    buyable: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.ProductData.ProductCustomerGroup}
 */
proto.no.jotta.internal.ProductData.ProductCustomerGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.ProductData.ProductCustomerGroup;
  return proto.no.jotta.internal.ProductData.ProductCustomerGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.ProductData.ProductCustomerGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.ProductData.ProductCustomerGroup}
 */
proto.no.jotta.internal.ProductData.ProductCustomerGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerGroupCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBuyable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.ProductData.ProductCustomerGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.ProductData.ProductCustomerGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.ProductData.ProductCustomerGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.ProductData.ProductCustomerGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerGroupCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBuyable();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string customer_group_code = 1;
 * @return {string}
 */
proto.no.jotta.internal.ProductData.ProductCustomerGroup.prototype.getCustomerGroupCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.ProductData.ProductCustomerGroup} returns this
 */
proto.no.jotta.internal.ProductData.ProductCustomerGroup.prototype.setCustomerGroupCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool buyable = 2;
 * @return {boolean}
 */
proto.no.jotta.internal.ProductData.ProductCustomerGroup.prototype.getBuyable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.internal.ProductData.ProductCustomerGroup} returns this
 */
proto.no.jotta.internal.ProductData.ProductCustomerGroup.prototype.setBuyable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.no.jotta.internal.ProductData.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.ProductData} returns this
 */
proto.no.jotta.internal.ProductData.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.no.jotta.internal.ProductData.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.ProductData} returns this
 */
proto.no.jotta.internal.ProductData.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ProductPrices prices = 3;
 * @return {?proto.no.jotta.internal.ProductPrices}
 */
proto.no.jotta.internal.ProductData.prototype.getPrices = function() {
  return /** @type{?proto.no.jotta.internal.ProductPrices} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.internal.ProductPrices, 3));
};


/**
 * @param {?proto.no.jotta.internal.ProductPrices|undefined} value
 * @return {!proto.no.jotta.internal.ProductData} returns this
*/
proto.no.jotta.internal.ProductData.prototype.setPrices = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.internal.ProductData} returns this
 */
proto.no.jotta.internal.ProductData.prototype.clearPrices = function() {
  return this.setPrices(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.internal.ProductData.prototype.hasPrices = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated ProductCustomerGroup customer_groups = 19;
 * @return {!Array<!proto.no.jotta.internal.ProductData.ProductCustomerGroup>}
 */
proto.no.jotta.internal.ProductData.prototype.getCustomerGroupsList = function() {
  return /** @type{!Array<!proto.no.jotta.internal.ProductData.ProductCustomerGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.internal.ProductData.ProductCustomerGroup, 19));
};


/**
 * @param {!Array<!proto.no.jotta.internal.ProductData.ProductCustomerGroup>} value
 * @return {!proto.no.jotta.internal.ProductData} returns this
*/
proto.no.jotta.internal.ProductData.prototype.setCustomerGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 19, value);
};


/**
 * @param {!proto.no.jotta.internal.ProductData.ProductCustomerGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.internal.ProductData.ProductCustomerGroup}
 */
proto.no.jotta.internal.ProductData.prototype.addCustomerGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 19, opt_value, proto.no.jotta.internal.ProductData.ProductCustomerGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.internal.ProductData} returns this
 */
proto.no.jotta.internal.ProductData.prototype.clearCustomerGroupsList = function() {
  return this.setCustomerGroupsList([]);
};


/**
 * optional string category = 5;
 * @return {string}
 */
proto.no.jotta.internal.ProductData.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.ProductData} returns this
 */
proto.no.jotta.internal.ProductData.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 devices = 6;
 * @return {number}
 */
proto.no.jotta.internal.ProductData.prototype.getDevices = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.internal.ProductData} returns this
 */
proto.no.jotta.internal.ProductData.prototype.setDevices = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 mobile_devices = 7;
 * @return {number}
 */
proto.no.jotta.internal.ProductData.prototype.getMobileDevices = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.internal.ProductData} returns this
 */
proto.no.jotta.internal.ProductData.prototype.setMobileDevices = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 user_seat_count = 8;
 * @return {number}
 */
proto.no.jotta.internal.ProductData.prototype.getUserSeatCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.internal.ProductData} returns this
 */
proto.no.jotta.internal.ProductData.prototype.setUserSeatCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool show_in_register_form = 9;
 * @return {boolean}
 */
proto.no.jotta.internal.ProductData.prototype.getShowInRegisterForm = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.internal.ProductData} returns this
 */
proto.no.jotta.internal.ProductData.prototype.setShowInRegisterForm = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool prices_without_vat = 11;
 * @return {boolean}
 */
proto.no.jotta.internal.ProductData.prototype.getPricesWithoutVat = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.internal.ProductData} returns this
 */
proto.no.jotta.internal.ProductData.prototype.setPricesWithoutVat = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string translate_key = 12;
 * @return {string}
 */
proto.no.jotta.internal.ProductData.prototype.getTranslateKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.ProductData} returns this
 */
proto.no.jotta.internal.ProductData.prototype.setTranslateKey = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional no.jotta.openapi.subscription.v2.SubscriptionInterval interval = 13;
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval}
 */
proto.no.jotta.internal.ProductData.prototype.getInterval = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} value
 * @return {!proto.no.jotta.internal.ProductData} returns this
 */
proto.no.jotta.internal.ProductData.prototype.setInterval = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional string type = 14;
 * @return {string}
 */
proto.no.jotta.internal.ProductData.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.ProductData} returns this
 */
proto.no.jotta.internal.ProductData.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string role = 15;
 * @return {string}
 */
proto.no.jotta.internal.ProductData.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.ProductData} returns this
 */
proto.no.jotta.internal.ProductData.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string display_params_json = 16;
 * @return {string}
 */
proto.no.jotta.internal.ProductData.prototype.getDisplayParamsJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.ProductData} returns this
 */
proto.no.jotta.internal.ProductData.prototype.setDisplayParamsJson = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string parent_product = 17;
 * @return {string}
 */
proto.no.jotta.internal.ProductData.prototype.getParentProduct = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.ProductData} returns this
 */
proto.no.jotta.internal.ProductData.prototype.setParentProduct = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string product_group = 18;
 * @return {string}
 */
proto.no.jotta.internal.ProductData.prototype.getProductGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.ProductData} returns this
 */
proto.no.jotta.internal.ProductData.prototype.setProductGroup = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.GetProductResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.GetProductResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.GetProductResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.GetProductResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    product: (f = msg.getProduct()) && proto.no.jotta.internal.Product.toObject(includeInstance, f),
    productData: (f = msg.getProductData()) && proto.no.jotta.internal.ProductData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.GetProductResponse}
 */
proto.no.jotta.internal.GetProductResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.GetProductResponse;
  return proto.no.jotta.internal.GetProductResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.GetProductResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.GetProductResponse}
 */
proto.no.jotta.internal.GetProductResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.internal.Product;
      reader.readMessage(value,proto.no.jotta.internal.Product.deserializeBinaryFromReader);
      msg.setProduct(value);
      break;
    case 2:
      var value = new proto.no.jotta.internal.ProductData;
      reader.readMessage(value,proto.no.jotta.internal.ProductData.deserializeBinaryFromReader);
      msg.setProductData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.GetProductResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.GetProductResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.GetProductResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.GetProductResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProduct();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.internal.Product.serializeBinaryToWriter
    );
  }
  f = message.getProductData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.internal.ProductData.serializeBinaryToWriter
    );
  }
};


/**
 * optional Product product = 1;
 * @return {?proto.no.jotta.internal.Product}
 */
proto.no.jotta.internal.GetProductResponse.prototype.getProduct = function() {
  return /** @type{?proto.no.jotta.internal.Product} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.internal.Product, 1));
};


/**
 * @param {?proto.no.jotta.internal.Product|undefined} value
 * @return {!proto.no.jotta.internal.GetProductResponse} returns this
*/
proto.no.jotta.internal.GetProductResponse.prototype.setProduct = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.internal.GetProductResponse} returns this
 */
proto.no.jotta.internal.GetProductResponse.prototype.clearProduct = function() {
  return this.setProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.internal.GetProductResponse.prototype.hasProduct = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ProductData product_data = 2;
 * @return {?proto.no.jotta.internal.ProductData}
 */
proto.no.jotta.internal.GetProductResponse.prototype.getProductData = function() {
  return /** @type{?proto.no.jotta.internal.ProductData} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.internal.ProductData, 2));
};


/**
 * @param {?proto.no.jotta.internal.ProductData|undefined} value
 * @return {!proto.no.jotta.internal.GetProductResponse} returns this
*/
proto.no.jotta.internal.GetProductResponse.prototype.setProductData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.internal.GetProductResponse} returns this
 */
proto.no.jotta.internal.GetProductResponse.prototype.clearProductData = function() {
  return this.setProductData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.internal.GetProductResponse.prototype.hasProductData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.GetScopedProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.GetScopedProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.GetScopedProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.GetScopedProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    productCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    customerGroupCode: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.GetScopedProductRequest}
 */
proto.no.jotta.internal.GetScopedProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.GetScopedProductRequest;
  return proto.no.jotta.internal.GetScopedProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.GetScopedProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.GetScopedProductRequest}
 */
proto.no.jotta.internal.GetScopedProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerGroupCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.GetScopedProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.GetScopedProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.GetScopedProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.GetScopedProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomerGroupCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string product_code = 1;
 * @return {string}
 */
proto.no.jotta.internal.GetScopedProductRequest.prototype.getProductCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.GetScopedProductRequest} returns this
 */
proto.no.jotta.internal.GetScopedProductRequest.prototype.setProductCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string customer_group_code = 2;
 * @return {string}
 */
proto.no.jotta.internal.GetScopedProductRequest.prototype.getCustomerGroupCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.GetScopedProductRequest} returns this
 */
proto.no.jotta.internal.GetScopedProductRequest.prototype.setCustomerGroupCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.internal.GetScopedProductResponse.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.GetScopedProductResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.GetScopedProductResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.GetScopedProductResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.GetScopedProductResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    nameLocalized: (f = msg.getNameLocalized()) && proto.no.jotta.internal.Translations.toObject(includeInstance, f),
    monthlyPricesList: jspb.Message.toObjectList(msg.getMonthlyPricesList(),
    no_jotta_openapi_subscription_payment_v2_pb.Money.toObject, includeInstance),
    yearlyPricesList: jspb.Message.toObjectList(msg.getYearlyPricesList(),
    no_jotta_openapi_subscription_payment_v2_pb.Money.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.GetScopedProductResponse}
 */
proto.no.jotta.internal.GetScopedProductResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.GetScopedProductResponse;
  return proto.no.jotta.internal.GetScopedProductResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.GetScopedProductResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.GetScopedProductResponse}
 */
proto.no.jotta.internal.GetScopedProductResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.internal.Translations;
      reader.readMessage(value,proto.no.jotta.internal.Translations.deserializeBinaryFromReader);
      msg.setNameLocalized(value);
      break;
    case 2:
      var value = new no_jotta_openapi_subscription_payment_v2_pb.Money;
      reader.readMessage(value,no_jotta_openapi_subscription_payment_v2_pb.Money.deserializeBinaryFromReader);
      msg.addMonthlyPrices(value);
      break;
    case 3:
      var value = new no_jotta_openapi_subscription_payment_v2_pb.Money;
      reader.readMessage(value,no_jotta_openapi_subscription_payment_v2_pb.Money.deserializeBinaryFromReader);
      msg.addYearlyPrices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.GetScopedProductResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.GetScopedProductResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.GetScopedProductResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.GetScopedProductResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNameLocalized();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.internal.Translations.serializeBinaryToWriter
    );
  }
  f = message.getMonthlyPricesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      no_jotta_openapi_subscription_payment_v2_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getYearlyPricesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      no_jotta_openapi_subscription_payment_v2_pb.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional Translations name_localized = 1;
 * @return {?proto.no.jotta.internal.Translations}
 */
proto.no.jotta.internal.GetScopedProductResponse.prototype.getNameLocalized = function() {
  return /** @type{?proto.no.jotta.internal.Translations} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.internal.Translations, 1));
};


/**
 * @param {?proto.no.jotta.internal.Translations|undefined} value
 * @return {!proto.no.jotta.internal.GetScopedProductResponse} returns this
*/
proto.no.jotta.internal.GetScopedProductResponse.prototype.setNameLocalized = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.internal.GetScopedProductResponse} returns this
 */
proto.no.jotta.internal.GetScopedProductResponse.prototype.clearNameLocalized = function() {
  return this.setNameLocalized(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.internal.GetScopedProductResponse.prototype.hasNameLocalized = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated no.jotta.openapi.subscription.v2.Money monthly_prices = 2;
 * @return {!Array<!proto.no.jotta.openapi.subscription.v2.Money>}
 */
proto.no.jotta.internal.GetScopedProductResponse.prototype.getMonthlyPricesList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.subscription.v2.Money>} */ (
    jspb.Message.getRepeatedWrapperField(this, no_jotta_openapi_subscription_payment_v2_pb.Money, 2));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.subscription.v2.Money>} value
 * @return {!proto.no.jotta.internal.GetScopedProductResponse} returns this
*/
proto.no.jotta.internal.GetScopedProductResponse.prototype.setMonthlyPricesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.Money=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.subscription.v2.Money}
 */
proto.no.jotta.internal.GetScopedProductResponse.prototype.addMonthlyPrices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.no.jotta.openapi.subscription.v2.Money, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.internal.GetScopedProductResponse} returns this
 */
proto.no.jotta.internal.GetScopedProductResponse.prototype.clearMonthlyPricesList = function() {
  return this.setMonthlyPricesList([]);
};


/**
 * repeated no.jotta.openapi.subscription.v2.Money yearly_prices = 3;
 * @return {!Array<!proto.no.jotta.openapi.subscription.v2.Money>}
 */
proto.no.jotta.internal.GetScopedProductResponse.prototype.getYearlyPricesList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.subscription.v2.Money>} */ (
    jspb.Message.getRepeatedWrapperField(this, no_jotta_openapi_subscription_payment_v2_pb.Money, 3));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.subscription.v2.Money>} value
 * @return {!proto.no.jotta.internal.GetScopedProductResponse} returns this
*/
proto.no.jotta.internal.GetScopedProductResponse.prototype.setYearlyPricesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.Money=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.subscription.v2.Money}
 */
proto.no.jotta.internal.GetScopedProductResponse.prototype.addYearlyPrices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.no.jotta.openapi.subscription.v2.Money, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.internal.GetScopedProductResponse} returns this
 */
proto.no.jotta.internal.GetScopedProductResponse.prototype.clearYearlyPricesList = function() {
  return this.setYearlyPricesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.AddPriceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.AddPriceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.AddPriceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.AddPriceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    productCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    currency: jspb.Message.getFieldWithDefault(msg, 2, 0),
    priceInCents: jspb.Message.getFieldWithDefault(msg, 3, 0),
    renewalPriceInCents: jspb.Message.getFieldWithDefault(msg, 4, 0),
    interval: jspb.Message.getFieldWithDefault(msg, 5, 0),
    startsAtMillis: jspb.Message.getFieldWithDefault(msg, 6, 0),
    customerGroupCode: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.AddPriceRequest}
 */
proto.no.jotta.internal.AddPriceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.AddPriceRequest;
  return proto.no.jotta.internal.AddPriceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.AddPriceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.AddPriceRequest}
 */
proto.no.jotta.internal.AddPriceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductCode(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.Currency} */ (reader.readEnum());
      msg.setCurrency(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPriceInCents(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRenewalPriceInCents(value);
      break;
    case 5:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (reader.readEnum());
      msg.setInterval(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartsAtMillis(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerGroupCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.AddPriceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.AddPriceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.AddPriceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.AddPriceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPriceInCents();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRenewalPriceInCents();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getInterval();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getStartsAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getCustomerGroupCode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string product_code = 1;
 * @return {string}
 */
proto.no.jotta.internal.AddPriceRequest.prototype.getProductCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.AddPriceRequest} returns this
 */
proto.no.jotta.internal.AddPriceRequest.prototype.setProductCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional no.jotta.openapi.subscription.v2.Currency currency = 2;
 * @return {!proto.no.jotta.openapi.subscription.v2.Currency}
 */
proto.no.jotta.internal.AddPriceRequest.prototype.getCurrency = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.Currency} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.Currency} value
 * @return {!proto.no.jotta.internal.AddPriceRequest} returns this
 */
proto.no.jotta.internal.AddPriceRequest.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 price_in_cents = 3;
 * @return {number}
 */
proto.no.jotta.internal.AddPriceRequest.prototype.getPriceInCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.internal.AddPriceRequest} returns this
 */
proto.no.jotta.internal.AddPriceRequest.prototype.setPriceInCents = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 renewal_price_in_cents = 4;
 * @return {number}
 */
proto.no.jotta.internal.AddPriceRequest.prototype.getRenewalPriceInCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.internal.AddPriceRequest} returns this
 */
proto.no.jotta.internal.AddPriceRequest.prototype.setRenewalPriceInCents = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional no.jotta.openapi.subscription.v2.SubscriptionInterval interval = 5;
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval}
 */
proto.no.jotta.internal.AddPriceRequest.prototype.getInterval = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} value
 * @return {!proto.no.jotta.internal.AddPriceRequest} returns this
 */
proto.no.jotta.internal.AddPriceRequest.prototype.setInterval = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int64 starts_at_millis = 6;
 * @return {number}
 */
proto.no.jotta.internal.AddPriceRequest.prototype.getStartsAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.internal.AddPriceRequest} returns this
 */
proto.no.jotta.internal.AddPriceRequest.prototype.setStartsAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string customer_group_code = 7;
 * @return {string}
 */
proto.no.jotta.internal.AddPriceRequest.prototype.getCustomerGroupCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.AddPriceRequest} returns this
 */
proto.no.jotta.internal.AddPriceRequest.prototype.setCustomerGroupCode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.AddPriceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.AddPriceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.AddPriceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.AddPriceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    price: (f = msg.getPrice()) && proto.no.jotta.internal.ProductPrice.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.AddPriceResponse}
 */
proto.no.jotta.internal.AddPriceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.AddPriceResponse;
  return proto.no.jotta.internal.AddPriceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.AddPriceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.AddPriceResponse}
 */
proto.no.jotta.internal.AddPriceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.internal.ProductPrice;
      reader.readMessage(value,proto.no.jotta.internal.ProductPrice.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.AddPriceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.AddPriceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.AddPriceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.AddPriceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.internal.ProductPrice.serializeBinaryToWriter
    );
  }
};


/**
 * optional ProductPrice price = 1;
 * @return {?proto.no.jotta.internal.ProductPrice}
 */
proto.no.jotta.internal.AddPriceResponse.prototype.getPrice = function() {
  return /** @type{?proto.no.jotta.internal.ProductPrice} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.internal.ProductPrice, 1));
};


/**
 * @param {?proto.no.jotta.internal.ProductPrice|undefined} value
 * @return {!proto.no.jotta.internal.AddPriceResponse} returns this
*/
proto.no.jotta.internal.AddPriceResponse.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.internal.AddPriceResponse} returns this
 */
proto.no.jotta.internal.AddPriceResponse.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.internal.AddPriceResponse.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.AddProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.AddProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.AddProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.AddProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    productCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    customerGroupCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
    buyable: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    copyPricesFromCustomerGroupCode: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.AddProductRequest}
 */
proto.no.jotta.internal.AddProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.AddProductRequest;
  return proto.no.jotta.internal.AddProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.AddProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.AddProductRequest}
 */
proto.no.jotta.internal.AddProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerGroupCode(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBuyable(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCopyPricesFromCustomerGroupCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.AddProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.AddProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.AddProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.AddProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomerGroupCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBuyable();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string product_code = 1;
 * @return {string}
 */
proto.no.jotta.internal.AddProductRequest.prototype.getProductCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.AddProductRequest} returns this
 */
proto.no.jotta.internal.AddProductRequest.prototype.setProductCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string customer_group_code = 2;
 * @return {string}
 */
proto.no.jotta.internal.AddProductRequest.prototype.getCustomerGroupCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.AddProductRequest} returns this
 */
proto.no.jotta.internal.AddProductRequest.prototype.setCustomerGroupCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool buyable = 3;
 * @return {boolean}
 */
proto.no.jotta.internal.AddProductRequest.prototype.getBuyable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.internal.AddProductRequest} returns this
 */
proto.no.jotta.internal.AddProductRequest.prototype.setBuyable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string copy_prices_from_customer_group_code = 4;
 * @return {string}
 */
proto.no.jotta.internal.AddProductRequest.prototype.getCopyPricesFromCustomerGroupCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.AddProductRequest} returns this
 */
proto.no.jotta.internal.AddProductRequest.prototype.setCopyPricesFromCustomerGroupCode = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.internal.AddProductRequest} returns this
 */
proto.no.jotta.internal.AddProductRequest.prototype.clearCopyPricesFromCustomerGroupCode = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.internal.AddProductRequest.prototype.hasCopyPricesFromCustomerGroupCode = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.AddProductResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.AddProductResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.AddProductResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.AddProductResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.AddProductResponse}
 */
proto.no.jotta.internal.AddProductResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.AddProductResponse;
  return proto.no.jotta.internal.AddProductResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.AddProductResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.AddProductResponse}
 */
proto.no.jotta.internal.AddProductResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.AddProductResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.AddProductResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.AddProductResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.AddProductResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.RemoveProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.RemoveProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.RemoveProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.RemoveProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    productCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    customerGroupCode: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.RemoveProductRequest}
 */
proto.no.jotta.internal.RemoveProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.RemoveProductRequest;
  return proto.no.jotta.internal.RemoveProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.RemoveProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.RemoveProductRequest}
 */
proto.no.jotta.internal.RemoveProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerGroupCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.RemoveProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.RemoveProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.RemoveProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.RemoveProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomerGroupCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string product_code = 1;
 * @return {string}
 */
proto.no.jotta.internal.RemoveProductRequest.prototype.getProductCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.RemoveProductRequest} returns this
 */
proto.no.jotta.internal.RemoveProductRequest.prototype.setProductCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string customer_group_code = 2;
 * @return {string}
 */
proto.no.jotta.internal.RemoveProductRequest.prototype.getCustomerGroupCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.internal.RemoveProductRequest} returns this
 */
proto.no.jotta.internal.RemoveProductRequest.prototype.setCustomerGroupCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.internal.RemoveProductResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.internal.RemoveProductResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.internal.RemoveProductResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.RemoveProductResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.internal.RemoveProductResponse}
 */
proto.no.jotta.internal.RemoveProductResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.internal.RemoveProductResponse;
  return proto.no.jotta.internal.RemoveProductResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.internal.RemoveProductResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.internal.RemoveProductResponse}
 */
proto.no.jotta.internal.RemoveProductResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.internal.RemoveProductResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.internal.RemoveProductResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.internal.RemoveProductResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.internal.RemoveProductResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.no.jotta.internal.SubscriptionInterval = {
  UNKNOWN_INTERVAL: 0,
  MONTHLY: 1,
  YEARLY: 2
};

/**
 * @enum {number}
 */
proto.no.jotta.internal.IAPType = {
  UNKNOWN_IAP_TYPE: 0,
  APPLE_STORE: 1,
  GOOGLE_PLAY: 2
};

goog.object.extend(exports, proto.no.jotta.internal);
